import { HelpCircle } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";

export function HelpTooltip({ content, className = "" }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
        className={cn(
          "inline-flex items-center justify-center",
          "text-gray-400 hover:text-purple-600 transition-colors",
          "focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-1 rounded-full",
          className
        )}
      >
        <HelpCircle className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute z-50 w-72 p-3 mt-2 text-sm bg-gray-900 text-white rounded-lg shadow-lg left-1/2 transform -translate-x-1/2">
          <div className="relative">
            {/* Flecha hacia arriba */}
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2">
              <div className="border-8 border-transparent border-b-gray-900"></div>
            </div>

            {/* Contenido del tooltip */}
            <div className="space-y-2">
              {typeof content === 'string' ? (
                <p className="leading-relaxed">{content}</p>
              ) : (
                content
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
